export default "__VITE_ASSET__DKLdx5da__"